import { getCookie } from "@repo/client-cookies";

/**
 * Reads the geocountry cookie value which contains the Akamai-determined country of the user
 * @returns The geocountry cookie value or null if not found
 */
export const getCustomerGeoCountry = (): string => {
  const geocountryCookie = getCookie("geocountry");
  return geocountryCookie || "GB";
};
